import { Box } from '@mui/material';
import React from 'react';

import { fontFeatureSettings, palette, typography } from '../../../assets/styles/themes/tokens';

const SEPARATOR_WIDTH = 7;

const separatorStyles = {
	...typography.body1,
	color: palette.text.disabled,
	fontFeatureSettings: fontFeatureSettings.disableLigatures,
	width: SEPARATOR_WIDTH,
	flexShrink: 0,
};

const BreadcrumbSeparator: React.FC = () => <Box sx={separatorStyles}>/</Box>;

export default BreadcrumbSeparator;
